// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8037":"8a1c076e3eaadbe0","8967":"727973242bb33abd"}[chunkId] + ".css";
};